import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/montserrat'
import '@fontsource/hind'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { initGA, logPageView } from "./analytics";

initGA();

// React 18 new rendering API
const container = document.getElementById('root');
const root = createRoot(container); // createRoot is from react-dom/client
root.render(
  <React.StrictMode>
    <App onRouteChange={logPageView} />
  </React.StrictMode>
);

// Report web vitals (optional)
reportWebVitals();

